import { Information } from '@components/Information';
import { Stack } from '@mui/material';
import { LabsAndFacilitySelect } from '../../LabsAndFacilitySelect';

export const ForOrderingProviders = () => {
  return (
    <Stack gap="24px" width="100%">
      <LabsAndFacilitySelect />
      <Information description="Only patients of the selected ordering providers will be included in the selection results." />
    </Stack>
  );
};
